document.addEventListener('DOMContentLoaded', () => {
    console.log("navbar script loaded");
    // Find Burger-Buttons
    const burgers = document.querySelectorAll('.navbar-burger');

    // Check if there are any navbar burgers
    if (burgers.length > 0) {
        // Add a click event on each of them
        burgers.forEach( el => {
            console.log("First", burgers.length);
            el.addEventListener('click', () => {
                // Get the target from the "data-target" attribute
                console.log("burgers found:", burgers.length);
                const targetId = el.dataset.target;
                const targetEl = document.getElementById(targetId);
                console.log("menu id ", targetEl)

                // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                el.classList.toggle('is-active');
                targetEl.classList.toggle('is-active');
            });
        });
    }
});
